(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8106],{

/***/ 89179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639),
    toInteger = __webpack_require__(40554),
    toNumber = __webpack_require__(14841),
    toString = __webpack_require__(79833);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),

/***/ 59854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRound = __webpack_require__(89179);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),

/***/ 99344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createOrder; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/helpers/misc/getErrorMessage.ts
var getErrorMessage = __webpack_require__(80102);
// EXTERNAL MODULE: ./src/components/Checkout/Confirm/makePayment.ts + 1 modules
var makePayment = __webpack_require__(12598);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/mutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation createOrder(\n    $addressId: ID\n    $storeId: ID\n    $menuId: ID\n    $deliveryType: String\n    $time: String\n    $paymentType: String\n    $otherPaymentType: String\n    $tipAmount: Float\n    $cashAmount: Float\n    $nationalId: String\n    $cardId: ID\n    $channel: String\n    $chatCommerceType: String\n    $couponCode: ID\n    $dropOffType: String\n    $tableName: String\n    $orderParams: JSON\n    $billing: JSON\n    $termSignatures: [TermSignatureInput]\n    $idempotencyKey: ID\n    $paymentData: JSON\n    $sessionEmail: String\n    $sessionPhone: String\n    $orderGroupId: ID\n    $isTableOrderV2: Boolean\n    $gift: GiftInput\n    $source: String\n    $checkoutVersion: String\n    $isTestOrder: Boolean\n    $websiteCoinsDiscount: Float\n  ) {\n    order: createOrder(\n      addressId: $addressId\n      storeId: $storeId\n      menuId: $menuId\n      deliveryType: $deliveryType\n      time: $time\n      paymentType: $paymentType\n      cashAmount: $cashAmount\n      nationalId: $nationalId\n      channel: $channel\n      chatCommerceType: $chatCommerceType\n      couponCode: $couponCode\n      otherPaymentType: $otherPaymentType\n      cardId: $cardId\n      tipAmount: $tipAmount\n      dropOffType: $dropOffType\n      tableName: $tableName\n      orderParams: $orderParams\n      billing: $billing\n      termSignatures: $termSignatures\n      idempotencyKey: $idempotencyKey\n      paymentData: $paymentData\n      sessionEmail: $sessionEmail\n      sessionPhone: $sessionPhone\n      orderGroupId: $orderGroupId\n      isTableOrderV2: $isTableOrderV2\n      gift: $gift\n      source: $source\n      checkoutVersion: $checkoutVersion\n      isTestOrder: $isTestOrder\n      websiteCoinsDiscount: $websiteCoinsDiscount\n    ) {\n      _id\n      code\n      paymentStatus\n      websiteId\n      paymentType\n      totalPrice\n      totalItems\n      amountToPay\n      tipAmount\n      tableName\n      dropOffType\n      deliveryFee\n      orderGroupId\n      isTableOrderV2\n      items {\n        product {\n          _id\n          name\n          categories {\n            _id\n            internalName\n          }\n        }\n        amount\n        unitPrice\n      }\n      transaction {\n        _id\n        publicMeta\n      }\n      intent {\n        _id\n        intentPayload\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutation = ((0,lib["default"])(_templateObject()));

;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/createOrder.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

/* eslint-disable @typescript-eslint/ban-types */ 




function createOrder(_) {
    return _createOrder.apply(this, arguments);
};
function _createOrder() {
    _createOrder = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var mutate, history, options, setErrorMessage, setVerifyPhone, setCreateCard, setCVC, regenerateIdempotencyKey, paymentData, _checkoutVersion, checkoutVersion, order, ref, graphQLErrors, validationErrors;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    mutate = param.mutate, history = param.history, options = param.options, setErrorMessage = param.setErrorMessage, setVerifyPhone = param.setVerifyPhone, setCreateCard = param.setCreateCard, setCVC = param.setCVC, regenerateIdempotencyKey = param.regenerateIdempotencyKey, paymentData = param.paymentData, _checkoutVersion = param.checkoutVersion, checkoutVersion = _checkoutVersion === void 0 ? "v2" : _checkoutVersion;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return mutate({
                        mutation: mutation,
                        variables: _objectSpread({}, options, {
                            paymentData: paymentData
                        }),
                        refetchQueries: [
                            "getMyOrderPreferences",
                            "getUserOrderGroup"
                        ]
                    });
                case 4:
                    order = _ctx.sent.order;
                    if (options.isTableOrderV2) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 8;
                    return (0,makePayment/* default */.Z)(order, history);
                case 8:
                    (0,events.sendEvent)(events.EVENTS.pay.passValidations, {
                        checkoutVersion: checkoutVersion
                    });
                    return _ctx.abrupt("return", order);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](1);
                    ref = _slicedToArray(_ctx.t0 && _ctx.t0.graphQLErrors ? _ctx.t0.graphQLErrors : [], 1), graphQLErrors = ref[0];
                    (0,events.sendEvent)(events.EVENTS.pay.failed, _objectSpread({}, graphQLErrors, {
                        checkoutVersion: checkoutVersion
                    }));
                    if (_ctx.t0.graphQLErrors && regenerateIdempotencyKey) {
                        regenerateIdempotencyKey();
                    }
                    if (graphQLErrors && graphQLErrors.validationErrors) {
                        validationErrors = graphQLErrors.validationErrors;
                        if (validationErrors.paymentType === "required") {
                            setErrorMessage("Por favor selecciona un medio de pago");
                        } else if (validationErrors.cardId === "required") {
                            setCreateCard(true);
                        } else if (validationErrors.cardId === "cardIncompatibleWithCoupon") {
                            setErrorMessage("Tarjeta de cr\xe9dito no compatible con descuento");
                        } else if (validationErrors.cvc === "required") {
                            setCVC(true);
                        } else if (validationErrors.cashAmount === "required") {
                            setErrorMessage("Por favor dinos con cuanto vas a pagar para llevar vuelto");
                        } else if (validationErrors.nationalId === "required" || validationErrors.nationalId === "invalid") {
                            setErrorMessage("El n\xfamero de identificaci\xf3n nacional ingresado es inv\xe1lido");
                        } else if (validationErrors.phone === "required") {
                            setErrorMessage("Por favor escribe tu tel\xe9fono, es necesario para llamarte si tenemos dudas");
                        } else if (validationErrors.phone === "requireVerification") {
                            setVerifyPhone({
                                single: false
                            });
                        } else if (validationErrors.phone === "requireSingleUseVerification") {
                            setVerifyPhone({
                                single: true,
                                verificationId: validationErrors.verificationId
                            });
                        } else if (validationErrors.fraud === "retry") {
                            (0,fireEvent["default"])("suggestPaymentChange", validationErrors);
                            setErrorMessage(validationErrors.clientMessage);
                        } else if (Object.keys(validationErrors).find(function(errorKey) {
                            return errorKey.startsWith("orderParams");
                        })) {
                            (0,fireEvent["default"])("orderParamsError", validationErrors);
                        } else if (validationErrors.orderGroupId === "closed") {
                            setErrorMessage(validationErrors.message);
                        } else if (validationErrors["gift.receiverPhone"] === "invalidPhoneLength") {
                            setErrorMessage("El largo del tel\xe9fono del que recibe el regalo es inv\xe1lido");
                        } else {
                            (0,fireEvent["default"])("createOrderError", _ctx.t0);
                            setErrorMessage((0,getErrorMessage/* default */.Z)(_ctx.t0));
                        }
                    } else {
                        (0,fireEvent["default"])("createOrderError", _ctx.t0);
                        setErrorMessage((0,getErrorMessage/* default */.Z)(_ctx.t0));
                    }
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return _createOrder.apply(this, arguments);
}


/***/ }),

/***/ 76160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRedirectUrl; }
/* harmony export */ });
function getRedirectUrl(param) {
    var paymentType = param.paymentType, transaction = param.transaction, intent = param.intent;
    if (!transaction && !intent) return {};
    if ([
        "orion",
        "khipu",
        "amipass"
    ].includes(paymentType)) {
        var publicMeta = transaction.publicMeta;
        return {
            url: publicMeta.start,
            post: false
        };
    }
    if ([
        "webpay",
        "webpayCurry"
    ].includes(paymentType)) {
        var publicMeta1 = transaction.publicMeta;
        return {
            url: publicMeta1.start,
            post: true
        };
    }
    if ([
        "kushkiCOPSE",
        "sodexo",
        "edenred",
        "mercadoPagoPSECO",
        "mercadoPagoWalletCO",
        "kushkiWebpay"
    ].includes(paymentType)) {
        var start = intent.intentPayload.start;
        return {
            url: start,
            post: false
        };
    }
    return {};
};


/***/ }),

/***/ 12598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makePayment; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/index.js
var lib = __webpack_require__(5275);
;// CONCATENATED MODULE: ./src/helpers/misc/getTrackPath.ts
function getTrackPath(router, websiteId, orderId) {
    if (typeof router.query.isChat === "string" && router.query.isChat === "true") {
        return "/chat/".concat(websiteId, "/track/").concat(orderId);
    }
    return "/track/".concat(orderId);
};

// EXTERNAL MODULE: ./src/components/Checkout/Confirm/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(76160);
// EXTERNAL MODULE: ./src/components/Checkout/Confirm/redirect.ts
var redirect = __webpack_require__(91995);
;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/makePayment.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function makePayment(order, router) {
    return _makePayment.apply(this, arguments);
};
function _makePayment() {
    _makePayment = _asyncToGenerator(runtime_default().mark(function _callee(order, router) {
        var ref, url, post;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,getRedirectUrl/* default */.Z)({
                        paymentType: order.paymentType,
                        transaction: order.transaction,
                        intent: order.intent
                    }), url = ref.url, post = ref.post;
                    if (post === true) {
                        (0,redirect/* default */.Z)(url);
                    } else if (url) {
                        (0,lib/* fireEvent */.BX)("setPaymentRedirectUrl", url);
                        window.location.replace(url);
                    } else {
                        router.replace(getTrackPath(router, order.websiteId, order._id));
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _makePayment.apply(this, arguments);
}


/***/ }),

/***/ 91995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ redirect; }
/* harmony export */ });
function redirect(param) {
    var url = param.url, token = param.token;
    var f = document.createElement("form");
    f.action = url;
    f.method = "POST";
    var i = document.createElement("input");
    i.type = "hidden";
    i.name = "token_ws";
    i.value = token;
    f.appendChild(i);
    document.body.appendChild(f);
    f.submit();
};


/***/ }),

/***/ 31000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DeliveryFeeText; }
/* harmony export */ });
/* harmony import */ var _i18n_formatNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78263);

function DeliveryFeeText(param) {
    var address = param.address, deliveryFee = param.deliveryFee;
    if (!address) return "Por calcular";
    if (deliveryFee === 0) return "Gratis";
    return (0,_i18n_formatNumber__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deliveryFee, "money");
};


/***/ }),

/***/ 80102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getErrorMessage; }
/* harmony export */ });
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32533);

function getValidationErrorString(param, keyToLabel) {
    var validationErrors = param.validationErrors;
    var keys = Object.keys(validationErrors);
    var texts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var code = validationErrors[key];
            var ref;
            var label = (ref = keyToLabel === null || keyToLabel === void 0 ? void 0 : keyToLabel[key]) !== null && ref !== void 0 ? ref : key;
            if (next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.t */ .ag.t) {
                var text = next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.t */ .ag.t("errors.".concat(code), {
                    label: label,
                    ns: "deprecated"
                });
                texts.push(text);
            } else {
                texts.push("".concat(label, ": ").concat(code));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return texts.join(", ");
}
function getErrorMessage(message, keyToLabel) {
    if (typeof message === "string") {
        return message;
    } else if (message.graphQLErrors) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.graphQLErrors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var graphError = _step.value;
                if (graphError.error === "validationError") {
                    return getValidationErrorString(graphError, keyToLabel);
                } else {
                    return graphError.message;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (message.message) {
        return message.message;
    } else {
        return message;
    }
};


/***/ }),

/***/ 60839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIdempotencyKey; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6882);


function useIdempotencyKey() {
    var key = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,_helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(32));
    return {
        idempotencyKey: key.current,
        regenerateIdempotencyKey: function() {
            key.current = (0,_helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(32);
        }
    };
};


/***/ })

}]);